module.exports = __webpack_public_path__ + "static/media/ult-secondary-variant-lock-up-fr.24b799af.svg";